export interface Comment {
  id: string;
  articleId: string;
  nickname: string;
  account: string;
  avatar: string;
  content: string;
  likes: number;
}

export const comments: Comment[] = [
  {
    id: '1',
    articleId: '1',
    nickname: '吃瓜群众甲',
    account: 'chigua_001',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20watermelon%20slice%20avatar%2C%20flat%20design%20style%2C%20warm%20green%20and%20coral%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-1&orientation=squarish',
    content: '人设崩塌来得太快就像龙卷风，这届粉丝太惨了，房子塌了一座又一座。',
    likes: 1234,
  },
  {
    id: '2',
    articleId: '1',
    nickname: '理性吃瓜人',
    account: 'lixing_007',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20thinking%20face%20avatar%2C%20flat%20design%20style%2C%20warm%20amber%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-2&orientation=squarish',
    content: '先别急着站队，等实锤出来再说吧。娱乐圈真真假假太多，吃瓜也要吃熟的。',
    likes: 892,
  },
  {
    id: '3',
    articleId: '3',
    nickname: '打工人代表',
    account: 'dagong_ren',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20worker%20with%20briefcase%20avatar%2C%20flat%20design%20style%2C%20warm%20brown%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-3&orientation=squarish',
    content: '14小时训练？这不就是互联网大厂的日常吗，只不过人家是在跳舞我们在写代码罢了。',
    likes: 2345,
  },
  {
    id: '4',
    articleId: '3',
    nickname: '前练习生',
    account: 'ex_trainee',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20mask%20avatar%2C%20flat%20design%20style%2C%20warm%20gray%20and%20coral%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-4&orientation=squarish',
    content: '太真实了，我当年也是这么过来的。退了之后感觉重获新生，虽然没出道但至少有尊严地活着。',
    likes: 3456,
  },
  {
    id: '5',
    articleId: '5',
    nickname: '5G冲浪选手',
    account: 'surf_5g',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20lightning%20bolt%20avatar%2C%20flat%20design%20style%2C%20warm%20yellow%20and%20coral%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-5&orientation=squarish',
    content: '这些梗我全都知道，我是不是冲浪时间太长了？建议出一个"网络梗精通度测试"。',
    likes: 1567,
  },
  {
    id: '6',
    articleId: '5',
    nickname: '梗图制造机',
    account: 'meme_master',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20robot%20making%20memes%20avatar%2C%20flat%20design%20style%2C%20warm%20green%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-6&orientation=squarish',
    content: '这些梗里面有一半都是我做的图，没想到今年产出这么多，感谢大家的喜欢！',
    likes: 2890,
  },
  {
    id: '7',
    articleId: '12',
    nickname: '泪点超低',
    account: 'cry_easy',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20tear%20drop%20avatar%2C%20flat%20design%20style%2C%20warm%20blue-tinted%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-7&orientation=squarish',
    content: '看完真的眼眶湿润了，这个世界还是有好多好人啊。希望大家都能被温柔以待。',
    likes: 4567,
  },
  {
    id: '8',
    articleId: '12',
    nickname: '人间观察员',
    account: 'observer_earth',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20eye%20with%20magnifying%20glass%20avatar%2C%20flat%20design%20style%2C%20warm%20coral%20and%20brown%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-8&orientation=squarish',
    content: '这种正能量内容多发点，每天看八卦看得我都要抑郁了，需要这种温暖中和一下。',
    likes: 2345,
  },
  {
    id: '9',
    articleId: '2',
    nickname: '日本通',
    account: 'japan_pro',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20torii%20gate%20avatar%2C%20flat%20design%20style%2C%20warm%20red%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-9&orientation=squarish',
    content: '日本人真的能把任何东西做成生意，棺材咖啡馆......下次去日本一定要体验一下。',
    likes: 987,
  },
  {
    id: '10',
    articleId: '2',
    nickname: '胆小勿入',
    account: 'scaredy_cat',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20scared%20cat%20avatar%2C%20flat%20design%20style%2C%20warm%20gray%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-10&orientation=squarish',
    content: '光是看图就觉得背后发凉，这真的能睡得着吗？我觉得我会做噩梦......',
    likes: 654,
  },
  {
    id: '11',
    articleId: '7',
    nickname: '圈内小透明',
    account: 'small_fry',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20small%20fish%20avatar%2C%20flat%20design%20style%2C%20warm%20blue-green%20and%20cream%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-11&orientation=squarish',
    content: '这个导演C某的风流韵事圈内人尽皆知，没想到这次玩大了。女方也是，为了资源也是拼了。',
    likes: 3456,
  },
  {
    id: '12',
    articleId: '7',
    nickname: '娱乐圈纪检委',
    account: 'discipline_committee',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20cartoon%20judge%20gavel%20avatar%2C%20flat%20design%20style%2C%20warm%20brown%20and%20gold%20colors%2C%20clean%20white%20background&width=100&height=100&seq=comment-avatar-12&orientation=squarish',
    content: '贵圈真乱，但最惨的还是粉丝。追了这么多年，发现偶像早就隐婚生子了，这谁能接受？',
    likes: 5678,
  },
];

export const getCommentsByArticleId = (articleId: string) => comments.filter((c) => c.articleId === articleId);